













































import { Component, Vue } from 'vue-property-decorator'
import { Mutation, State } from 'vuex-class'
import BusinessLicense from './BusinessLicense.vue'
import BusinessContacts from './BusinessContacts.vue'
import BusinessOthers from './BusinessOthers.vue'
import BusinessKefu from './BusinessKefu.vue'
import { companyInfo } from '../testData'
import * as api from '@/service/step-three'

@Component({
  components: {
    BusinessLicense,
    BusinessContacts,
    BusinessOthers,
    BusinessKefu,
  },
})
export default class StepsThree extends Vue {
  @State bidType!: number
  @State kefuChannel!: number
  @Mutation setKefuChannel!: Function

  companyInfo: any = {
    contractFiles: [],
  }
  loading = false
  isFetched = false

  async created() {
    await this.initData()
    this.isFetched = true
  }

  async initData() {
    const result = await api.queryCompanyInfo()
    result.authorize_url = result.authorize_url?.split(',')
    result.purchaser_name_arr=[]
    if(result.purchaser_name){
      result.purchaser_name_arr=result.purchaser_name?.split(',') || []
    }
   
    this.companyInfo = result
    if (this.companyInfo.service_channel != void 0 && this.kefuChannel == -1) this.setKefuChannel(this.companyInfo.service_channel)
    if (this.bidType === 6) {
      this.$set(this.companyInfo, 'contractFiles', [])
      const f: any[] = this.companyInfo.contractFiles
      const url = this.companyInfo.pop_contract_url
      if (url) {
        f.push({
          uid: url,
          url,
          name: url.split('/').pop(),
          $type: /\.(jpe?g|png)$/i.test(url)
            ? 'image'
            : /\.pdf$/.test(url)
            ? 'pdf'
            : 'file',
        })
      }
    }
  }

  changeCompanyInfo(value: object) {
    this.companyInfo = {
      ...this.companyInfo,
      ...value,
    }
  }

  async onSubmit() {
    let validValue = true
    if (this.bidType !== 8) {
      await (this.$refs.license as any)
        .validateForm()
        .validate((valid: boolean, e: any) => {
          validValue = valid
          if (!valid) {
            const err: any = Object.values(e)[0]
            this.$message.error(err[0].message)
          }
        })
    }
    if (validValue) {
      const valid = await (this.$refs.contacts as any).validate()
      validValue = valid
    }
    validValue &&
      (await (this.$refs.others as any).antForm.validate(
        (valid: boolean, e: any) => {
          validValue = valid
          if (!valid) {
            const err: any = Object.values(e)[0]
            this.$message.error(err[0].message)
          }
        }
      ))
    validValue &&
      (await (this.$refs.kefu as any).antForm.validate(
        (valid: boolean, e: any) => {
          validValue = valid
          if (!valid) {
            const err: any = Object.values(e)[0]
            this.$message.error(err[0].message)
          }
        }
      ))
    if (!validValue) return
    if (this.companyInfo.authorize_url instanceof Array) {
      this.companyInfo.authorize_url = this.companyInfo.authorize_url.join(',')
    }
    if (this.companyInfo.purchaser_name_arr instanceof Array) {
      this.companyInfo.purchaser_name = this.companyInfo.purchaser_name_arr.join(',')
    }
    if (this.companyInfo.person_card_type != 1) delete this.companyInfo.face_status
    this.companyInfo.service_channel = this.kefuChannel
    this.loading = true
    try {
      await api.saveCompanyInfo({
        ...this.companyInfo,
        bid_type: this.bidType,
      })
      this.$emit('forward')
    } catch (err) {
      console.error(err)
    }
    this.loading = false
  }

  doTest() {
    const { NODE_ENV, TARGET } = process.env
    if (NODE_ENV === 'development' || TARGET === 'test-build') {
      this.companyInfo = companyInfo(this.bidType)
    }
  }
}
